import Moment from 'moment';
import { saveAs } from 'file-saver';

async function saveResponseAsAsync(response, filename) {
    const blob = await response.blob();
    saveAs(blob, filename);
}

function saveTextAs(text, filename, type = "text/plain") {
    const blob = new Blob([text], { type });
    saveAs(blob, filename);
}

function getTimestampForFileName() {
    return Moment().format('YYYY-MM-DD HH-mm-ss');
}

export { saveResponseAsAsync, saveTextAs, getTimestampForFileName }
